import { useEffect, useRef } from "react";
import { useAuth } from "@/hooks/useAuth";
import { useAppSettings } from "@/hooks/useAppSettings";
import { speak } from "@/lib/speak";
import { supabase } from "@/integrations/supabase/client";
import { buildWelcomeMessage } from "@/lib/nameUtils";

const SESSION_KEY = "kelas-welcome-spoken";

const WelcomeVoice = () => {
  // Welcome voice greeting disabled per user preference.
  return null;
};

export default WelcomeVoice;